module.exports = __webpack_public_path__ + "img/hide.be5ce6ff.svg";